import { useState } from 'react';

export const useImportLogs = () => {
  const [logs, setLogs] = useState([]);

  const addLog = (message, type = 'info', phase = '', details = '') => {
    setLogs(prev => [...prev, { 
      message, 
      type,
      phase,
      details,
      timestamp: new Date().toISOString(),
    }]);
  };

  const LogViewer = () => {
    if (logs.length === 0) return null;

    return (
      <div className="bg-white shadow sm:rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-lg font-medium leading-6 text-gray-900 mb-4">Import Log</h3>
          <div className="bg-gray-50 rounded-lg p-4 h-64 overflow-auto">
            {logs.map((log, index) => (
              <div 
                key={index}
                className={`text-sm mb-2 ${
                  log.type === 'error' ? 'text-red-600' : 'text-gray-600'
                }`}
              >
                <div className="flex items-center gap-2">
                  <span className="text-gray-400">
                    [{new Date(log.timestamp).toLocaleTimeString()}]
                  </span>
                  {log.phase && (
                    <span className="bg-gray-200 text-gray-700 px-2 py-0.5 rounded-full text-xs">
                      {log.phase}
                    </span>
                  )}
                  <span>{log.message}</span>
                </div>
                {log.details && (
                  <pre className="mt-1 ml-4 text-xs bg-gray-100 p-2 rounded whitespace-pre-wrap">
                    {log.details}
                  </pre>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return {
    logs,
    addLog,
    LogViewer
  };
};
